import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtPresentacionesPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`pre_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articulospresentacion", queryString);
};

export const getArtPresentacionById = async (id) => {
    const res = await getData(`/articulospresentacion/${id}`)
    return res
}

export const postArtPresentacion = async (body) => {
    const res = await postData('/articulospresentacion', body)
    return res
}

export const deleteArtPresentacion = async (id) => {
    const res = await deleteData(`/articulospresentacion/${id}`)
    return res
}